import React, { useState, createContext, useContext } from 'react'

const DataContext = createContext();

export default function Data({ children }) {

    const [state, setState] = useState({ courses: [], campuses: [] })

    return (
        <DataContext.Provider value={{ ...state, setState }}>
            {children}
        </DataContext.Provider>
    )
}

export const useDataContext = () => useContext(DataContext)
